module.exports = __webpack_public_path__ + "static/media/bd4.5e71a343.jpg";